//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';


//-================ IMPORTS FOR CONSTANTS ================-\\
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { Annexe, FILE_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/File_FIN.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { FILE_FIN_LA } from 'src/app/Interfaces/Libraries/Library-FIN-int/File_FIN_LA.interface';
import { Download_Log_FIN } from 'src/app/Constants/Backlog/FIN/Download_Log_FIN';




@Component({
    selector: 'app-latest-approved-fin',
    templateUrl: './latest-approved-fin.component.html',
    styleUrls: ['./latest-approved-fin.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/LatestApprovedGlobal.css'],
    standalone: false
})
export class LatestApprovedFINComponent implements OnInit {

  //+================== VARIABLES FOR HEADERS LAST APPROVED ==================+\\
  public HeadersLA: Headers_CCP[] = [
    { ID: 1, Name: 'Versión', Position: 1, Visible: true, Key_Header: 'VER' },
    { ID: 1, Name: 'Nombre del Proceso', Position: 1, Visible: true, Key_Header: 'NAF' },
    { ID: 1, Name: 'Anexos', Position: 1, Visible: true, Key_Header: 'ANNEX' },
    { ID: 1, Name: 'Código', Position: 1, Visible: true, Key_Header: 'CODEF' },
    { ID: 1, Name: 'Objetivo del proceso', Position: 1, Visible: true, Key_Header: 'DES' },
    { ID: 1, Name: 'Fecha de carga', Position: 1, Visible: true, Key_Header: 'DAC' },
    { ID: 1, Name: 'Fecha de aprobación', Position: 1, Visible: true, Key_Header: 'DAA' },
    { ID: 1, Name: 'Mgr. Process Owner', Position: 1, Visible: true, Key_Header: 'APP1' },
    { ID: 1, Name: 'RM & ICS Specialist', Position: 1, Visible: true, Key_Header: 'APP2' },
    { ID: 1, Name: 'RM & ICS Sr. Mgr.', Position: 1, Visible: true, Key_Header: 'APP3' },
    { ID: 1, Name: 'Director or CFO', Position: 1, Visible: true, Key_Header: 'APP4' },
  ];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR KEYS SNAPSHOTS ==================+\\
  private ID_FIN: number = 0;

  //+================== VARIABLES FOR FIN DOCUMENT ==================+\\

  public LastApprovedFIN: FILE_FIN_LA = {
    ID: 0,
    Extension: '',
    Name: '',
    Code: '',
    Purpose: '',
    Revision_No: 0,
    Status: 0,
    ID_Folder: 0,
    ID_Involved_User_Task1: 0,
    ID_Involved_User_Task2: 0,
    ID_Involved_User_Task3: 0,
    ID_Involved_User_Task4: 0,
    Approver1_Name: '',
    Approver2_Name: '',
    Approver3_Name: '',
    Approver4_Name: '',
    Annexes: [],
    Date_Created: null,
    Date_Expiration: null,
    Date_End: null,
    ID_Contributor: 0,
    Contributor_Name: '',
    ID_Previous_Version: null,
    ID_Next_Version: null,
    Status_System: 0,
    Directory: false,
    Path: '',
  }

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;

  public Load_Page: boolean = false;

  //-========================= SERVICES =========================-\\

  private Service_FIN = inject(LibraryFINService);
  private activatedRouter = inject(ActivatedRoute);

  constructor() {
    this.ID_FIN = Number(this.activatedRouter.snapshot.params['idC']);
  }

  ngOnInit(): void {
    this.Load_Component_LA();
  }


  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component_LA(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    this.Load_Page = false;

    try {

      const ResLastApproved: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Last_Version_Approved({ ID_FIN: this.ID_FIN }));

      if (ResLastApproved.success) {

        this.Load_Page = true;

        if (!ResLastApproved.operation.Exist_VA) {

          Swal.fire({
            title: 'Sin versión aprobada',
            text: '¡El Proceso no tiene versiones anteriores aprobadas!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          }).then((result) => {
            window.close();
          })

        } else {

          this.LastApprovedFIN = ResLastApproved.operation.FIN;

        }
      }


      Loader.classList.remove('active');

    } catch (e) {


      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar la ultima versión aprobada, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
      Loader.classList.remove('active');
      this.Load_Page = true;
    }

  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR GENERAL LAST VERSION APPROVED =====================&\\

  //-================ FUNCTION FOR DATE FORMAT ================-\\
  public DateFormat(Date_Created: Date | null | undefined): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-============== FUNCTION FOR DOWNLOAD FILE ==============-\\
  public async DownloadFile(): Promise<void> {

    const Btn_Download = document.getElementById(`Btn-Download`) as HTMLButtonElement;
    const Progress_Bar_Task = document.getElementById(`Progress-Bar-Task`) as HTMLSpanElement;


    const Text_Btn = document.getElementById(`Text-Btn`) as HTMLElement;
    const Icon_Btn = document.getElementById(`Icon-Btn`) as HTMLElement;

    Btn_Download.classList.add('active');
    Btn_Download.disabled = true;

    try {

      const ResPrintFormat: Response_FIN = await firstValueFrom(this.Service_FIN.Generate_Print_Format_FIN({ ID_FIN: this.LastApprovedFIN.ID, Type_D: Download_Log_FIN.D_PRINT_FORMATF }));

      const URL = ResPrintFormat.operation.URL_FIN_PF;


      let Name_Split: string[] = this.LastApprovedFIN.Name.split('.'); Name_Split.pop();

      const Name_Download: string = `${Name_Split.join('.')}.${URL.split('.').pop()}`

      if (ResPrintFormat.success) {

        const IsDownload = this.Download_File_FIN(URL, Name_Download);
        Btn_Download.disabled = false;
          if (!IsDownload) throw new Error('No file Download');

      } else {
        throw "ERROR";
      }

    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar la última versión aprobada del Proceso, informa a tu supervisor!'
      });

      Btn_Download.classList.remove('active');
      Progress_Bar_Task.style.width = '0%';
      Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-xmark');
      Text_Btn.innerHTML = 'Error';
      Btn_Download.disabled = false;
    }




  }

  //-============== FUNCTION FOR DOWNLOAD FILE FIN ==============-\\
  private async Download_File_FIN(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const Btn_Download = document.getElementById(`Btn-Download`) as HTMLDivElement;
      const Progress_Bar_Task = document.getElementById(`Progress-Bar-Task`) as HTMLSpanElement;


      const Text_Btn = document.getElementById(`Text-Btn`) as HTMLElement;
      const Icon_Btn = document.getElementById(`Icon-Btn`) as HTMLElement;

      Btn_Download.classList.add('active');

      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Task.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          Progress_Bar_Task.style.width = '0%';
          Btn_Download.classList.remove('active');


          Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-check-double');
          Text_Btn.innerHTML = 'Completada';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Proceso descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el Proceso, informe a su supervisor!'
          })

          Btn_Download.classList.remove('active');
          Progress_Bar_Task.style.width = '0%';
          Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-xmark');
          Text_Btn.innerHTML = 'Error';

          resolve(false);
        }

      })
    })

  }


  //-============== FUNCTION FOR ADD CLASS ANNEXE ==============-\\
  public Contain_Annexe(Annexe: Annexe[]): string {

    return Annexe.length === 0 ? 'Not-Annexe' : 'Annexe';
  }

  //-============== FUNCTION FOR TEXT IF CONTAINS ANNEXE ==============-\\
  public Contain_Annexe_Text(Annexe: Annexe[]): string {

    return Annexe.length === 0 ? 'Sin anexos' : 'Ver annexos';
  }

  //-================== FUNCTION FOR CUT CODE ==================-\\
  public Cut_Code(Code: string): string {
    return Code.length > 15 ? Code.slice(0, 15) + '...' : Code;
  }

  //-================== FUNCTION FOR SEE CODE COMPLETE ==================-\\
  public See_Code(Code: string): void {
    Swal.fire({
      title: 'Código',
      text: Code,
      confirmButtonColor: this.ColorConfirm
    })
  }

  //-============== FUNCTION FOR CUT DESCRIPTION TABLE ==============-\\
  public Cut_Purpose(Purpose: string): string {
    return Purpose.length > 40 ? Purpose.slice(0, 40) + '...' : Purpose;
  }

  //-============== FUNCTION FOR SEE Purpose COMPLETE ==============-\\
  public See_Purpose(Purpose: string): void {
    Swal.fire({
      title: 'Objetivo del proceso',
      text: Purpose,
      confirmButtonColor: this.ColorConfirm
    })
  }

  public Get_Name_Approver(Name: string | null | undefined) {
    return Name === null ? 'No fue requerido' : Name;
  }

  //-============== FUNCTION FOR VERIFY IF CONTAINS ANNEXE ==============-\\
  public Can_See_Modal_Annexe(FIN: FILE_FIN): void {
    this.Modal_See_Annexe(true);
  }

  //-============== FUNCTION FOR OPEN OR CLOSE MODAL, FOR SEE ANNEXE ==============-\\
  public Modal_See_Annexe(CloseOrOpen: boolean): void {
    const Modal_See_Annexe = document.getElementById('Modal-See-Annexe') as HTMLDivElement;
    CloseOrOpen ? Modal_See_Annexe.classList.add('active') : Modal_See_Annexe.classList.remove('active');
  }

  //-============== VALIDATION FUNCTION TO DOWNLOAD ANNEX ==============-\\
  public Can_Download_Annexe(Annexe: Annexe): void {

    this.Get_Download_Annexe(Annexe);
  }

  //-============== FUNCTION TO GET ANNEX DOWNLOAD URL ==============-\\
  private async Get_Download_Annexe(Annexe: Annexe): Promise<void> {

    try {

      const ResGetURLFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Get_URL_Download_Annexe_FIN({ ID_Annexe: Annexe.ID, Type_D: Download_Log_FIN.D_ANNEX_LAST_VA }));

      if (ResGetURLFIN.success) {

        const URL = ResGetURLFIN.operation.URL_Annexe;

        const IsDownload = this.Download_Annexe_FIN(URL, Annexe.Name);

        if (!IsDownload) throw new Error('No file Download');
      }

    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar el anexo del Proceso, informa a tu supervisor!'
      })
    }

  }

  //-============== FUNCTION TO GET ANNEX DOWNLOAD URL ==============-\\
  private async Download_Annexe_FIN(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const Container_Download_Annexe = document.getElementById('Container-Download-Annexe') as HTMLDivElement;
      const Progress_Bar_Annexe = document.getElementById('Progress-Bar-Annexe') as HTMLDivElement;

      Container_Download_Annexe.classList.add('active');


      this.Service_FIN.Download_File_FIN(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Annexe.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          Container_Download_Annexe.classList.remove('active');
          Progress_Bar_Annexe.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Anexo descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el anexo de del Proceso, informe a su supervisor!'
          })

          Container_Download_Annexe.classList.remove('active');
          Progress_Bar_Annexe.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  //-================== FUNCTTION FOR CUT NAME ==================-\\
  public CutNameFile(Name: string, length: number): string {

    if (Name !== undefined) {
      if (Name.length > length) {
        const Ext = Name.split('.').pop();
        const NameCut = Name.slice(0, length);
        return NameCut + '....' + Ext;
      } else {
        return Name;
      }

    } else {
      return '';
    }
  }


  //&===================== END FUNCTIONS FOR GENERAL LAST VERSION APPROVED =====================&\\


}
